import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { twMerge } from "tailwind-merge";
import { partyLogo } from "@lib/assets";
import type { Party } from "@partiguiden/party-data/types";
import { partyNames } from "@partiguiden/party-data/utils";
interface PartyIconProps {
  party: Party;
  className?: string;
  sizes?: string;
}
export default function PartyIcon(t0) {
  const $ = _c(11);
  const {
    party,
    className,
    sizes: t1
  } = t0;
  const sizes = t1 === undefined ? "24px" : t1;
  let t2;
  if ($[0] !== className) {
    t2 = twMerge("relative h-6 w-6", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== party) {
    t3 = partyLogo(party);
    $[2] = party;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = `${partyNames[party]}s logga`;
  let t5;
  if ($[4] !== sizes || $[5] !== t3 || $[6] !== t4) {
    t5 = <Image src={t3} fill={true} sizes={sizes} className="object-cover" alt={t4} />;
    $[4] = sizes;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t2 || $[9] !== t5) {
    t6 = <div className={t2}>{t5}</div>;
    $[8] = t2;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}